import axios from "./index";

class UserApi {
  static me = () => {
    return axios.get(`${base}/me`);
  };

  static fetchUser = (identificacion) => {
    if (!identificacion) {
      return this.me();
    }
    return axios.get(`${base}/${identificacion}`);
  };

  static updateUser = (identificacion, data) => {
    if (!identificacion || identificacion === "undefined") {
      throw new Error("Identificación no válida para actualizar usuario");
    }
    return axios.put(`${base}/${identificacion}`, data);
  };

  static fetchUsuarios = async () => {
    try {
      const response = await axios.get(`${base}`);
      if (response.data && response.data.data) {
        return {
          data: response.data.data.map((user) => ({
            ...user,
            id: user.identificacion,
            //id: user.id,
            identificacion: user.identificacion,
            nombre_completo: user.nombre_completo || `${user.nombres} ${user.apellidos}`,
          })),
        };
      }
      return { data: [] };
    } catch (error) {
      console.error("Error fetching usuarios:", error);
      return { data: [] };
    }
  };

  static toggleActive = (identificacion) => {
    if (!identificacion || identificacion === "undefined") {
      throw new Error("Identificación no válida para cambiar estado");
    }
    return axios.post(`${base}/${identificacion}/toggle_active`);
  };
}

const base = "users";

export default UserApi;
